module.exports = __webpack_public_path__ + "img/wa-line2.f471387.png";